<template >
    <div class="appy_list" >
        <div class="appy_conent">
            <div class="appy_name">报名表</div>
            <div class="jgx"></div>
            <!-- 单位名称 -->
            <div style="margin-top: 32px;display: flex">
                <div class="unit_name" style="overflow:hidden;">单位名称：</div>
                <div style="width: 60%">
                    <input type="text" style="border: none;width: 90%"
                           class="unit_text" maxlength="30" v-model="appy_name"/>
                </div>
            </div>
            <div class="jgx_a"></div>

            <!-- 联系地址 -->
            <div style="margin-top: 24px;display: flex">
                <div class="unit_name">联系地址：</div>
                <div style="width: 60%">
                    <input type="text" style="border: none;width: 90%" class="unit_text"
                           v-model="appy_address" maxlength="30"/>
                </div>
            </div>
            <div class="jgx_a"></div>
            <!-- 联系人及电话 -->
            <div style="margin-top: 24px;display: flex">
                <div class="unit_name">联系人及电话：</div>
                <div style="width: 50%">
                    <input type="text" style="border: none;width: 90%" class="unit_text"
                           v-model="appy_telephone" maxlength="30"/>
                </div>
            </div>
            <div class="jgx_a"></div>
            <!--仪器型号-->
            <div >
                <div style="margin-top: 15px;">
                    <div class="unit_name">目前贵公司拥有的仪器及型号：</div>
                    <div style="margin-top: 20px; " class="jgx_b"
                         v-for="(item,index) in data" v-bind:key="index">
                        <div class="unit_name_a">{{item}}</div>
                        <div style="margin-right: 50px;margin-top: 15px">
                        <textarea class="unit_textarea"
                                  style=" border: none;width:100%;padding-right:100px"
                                  maxlength="100" v-model="values[index]"  rows="3"/>
                        </div>
                    </div>
<!--                    <div ></div>-->

                </div>
                <div class="jgx_a"></div>
                <!--需要学习的仪器及方向-->
                <div style="margin-top: 13px;">
                    <div class="unit_name" >{{li_direction[1]}}</div>
                    <div style="margin-left: 41px;margin-right: 50px;margin-top: 15px">
                    <textarea class="unit_textarea"
                              style=" border: none;width:100%;padding-right:100px"
                              rows="10" v-model="values[li_direction[0]]"/>
                </div>
                </div>
<!--                这里是接口需要的值{{values}}-->
                <div class="jgx_c"></div>
            </div>
            <!--提交-->
            <div class="button_list1" @click="chuanjian">提交</div>
        </div>

    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                appy_name: '',
                appy_telephone: '',
                appy_address: '',
                appy_xinghao1: '',
                appy_xinghao2: '',
                appy_yiqi: '',
                data: [],
                values: {},
                li_direction:"",
                li_brand:"",
                li_brand1:'',
            }
        },
        methods: {
            chuanjian() {
                var t = this
                var formData = new FormData();
                formData.append('huodong_id',this.$route.params.id);
                formData.append('name', t.appy_name);
                formData.append('telephone', t.appy_telephone);
                formData.append('address', t.appy_address);
                Object.entries(t.values).forEach(v => {
                    formData.append('attr['+v[0]+']',v[1]);
                })
                var post_url = window.config.api_url + '/college/huodong/baoming';
                this.axios.post(post_url, formData).then(function (res) {
                    console.log(res, '12121221')
                    t.open2('提交成功')
                    t.dianji()
                });
            },
            open2(eve) {//成功
                this.$message({
                    showClose: true,
                    message: eve,
                    type: 'success'
                });
            },
            dianji(){
             this.$router.push('/leaflet/'+this.$route.params.id);
             //    this.$router.push({path:'/leaflet/',query: {id:this.$route.params.id}})
            },
            huodonglist() {
                var t = this;
                var url = window.config.api_url + '/college/huodong/'+this.$route.params.id;
                t.axios.get(url).then((res) => {
                    console.log('shdfdsf',res.data)
                    let attr = res.data.baoming_attr;
                    t.li_direction = Object.entries(attr).find(v => v[0] == 'direction');
                    delete attr['direction'];
                    t.data= attr;
                    console.log('1212', t.data)
                })
            },
        },


        created: function () {
            document.title = '报名表'
            this.huodonglist()
        }
    }
</script>

<style scoped>
    .appy_list {
        background-image: url('~@/../src/assets/home/shops/beijing.png');
        /*background-size: 100vh 100vh;*/
        /*background-size:cover;*/
        height: 100%;
        position:fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: auto;
        /*height: auto;*/
        /*overflow: hidden;*/
        /*margin-bottom: 0;*/
    }

    .appy_conent {
        height: auto;
        background-color: #FFFFFF;
        margin-left: 14px;
        margin-right: 14px;
        margin-top: 23px;
        overflow: hidden;
        margin-bottom: 60px;

    }

    .appy_name {
        color: #3D6FF2;
        font-size: 20px;
        font-family: Adobe Heiti Std R;
        text-align: center;
        padding-top: 14px;
    }

    .jgx {
        border: 1px solid #3D6FF2;
        margin-left: 5px;
        margin-right: 5px;
        margin-top: 12px;
    }

    .unit_name {
        font-family: SourceHanSansCN-Regular;
        color: #333333;
        font-size: 14px;
        margin-left: 21px;
    }

    .unit_name_a {
        font-family: SourceHanSansCN-Regular;
        color: #333333;
        font-size: 14px;
        /*margin-left: 42px;*/
        overflow: hidden;
    }

    .unit_text {
        font-family: SourceHanSansCN-Regular;
        color: #333333;
        font-size: 13px;
    }

    .unit_textarea {
        font-family: SourceHanSansCN-Regular;
        color: #333333;
        font-size: 13px;

    }

    .jgx_a {
        border: 1px solid #BBB9B9;
        margin-left: 20px;
        margin-right: 6px;
        margin-top: 24px;
    }
    .jgx_b{
        padding-top:22px;
        margin-left: 41px;
    }
    .jgx_b+.jgx_b{
        /*border-bottom: 1px solid #BBB9B9;*/
        border-top: 1px solid #BBB9B9;

        margin-right: 41px;

        /*/-left: 41px;*!*/
        /*position: relative;*/
        /*top: -115px;*/
    }

    .jgx_c {
        border: 1px solid #BBB9B9;
        margin-left: 20px;
        margin-right: 6px;
    }

    .button_list1 {
        border-radius: 20px;
        background-color: #3D6FF2;
        width: 245px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin: auto;
        margin-top: 21px;
        margin-bottom: 25px;
        font-size: 16px;
        color: #ffffff;
    }
</style>